module.exports = __webpack_public_path__ + "static/media/ashthvinayak.856ef92b.jpg";